// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".change-password-page .error-text{margin-top:10px}", "",{"version":3,"sources":["webpack://./public/app/pages/change-password/change-password.style.scss"],"names":[],"mappings":"AACE,kCACE,eAAA","sourcesContent":[".change-password-page {\n  .error-text {\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
